// extracted by mini-css-extract-plugin
export default {"container":"lR-z","dimension":"mR-z","dimensionLabels":"nR-z"};